module.exports = __webpack_public_path__ + "static/media/schedLimitMinus.58577e1d.svg";